import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PaymentSchema } from "../../Schemas/Payment";

interface Filter extends IFilterSchema {
  column: PaymentListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: PaymentListColumnSortable;
}

export enum PaymentVerifyingStatusEnum {
  PENDING = "pending",
  PAYING = "paying",
  PAID = "paid",
  FAILED = "failed",
}

export enum PaymentListColumnFilterable {
  ID = "id",
  NAME = "name",
  CAPTION = "caption",
  DISK = "disk",
  TYPE = "type",
  SIZE = "size",
  LENGTH = "length",
  VERIFYING_STATUS = "verifying_status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}
export enum PaymentListColumnSortable {
  ID = "id",
  NAME = "name",
  CAPTION = "caption",
  DISK = "disk",
  TYPE = "type",
  SIZE = "size",
  LENGTH = "length",
  VERIFYING_STATUS = "verifying_status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}

interface PaymentListUrlParams {
  workspaceId: number;
}

interface PaymentListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

interface PaymentListResponseBody extends IResponseBody {
  data: {
    payment_receipts: PaymentSchema[];
    total: number;
  };
}

export class PaymentListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(workspaceId: number) {
    return `/panel/workspace/${workspaceId}/payment-receipts`;
  }

  async send(
    contactListUrlParams: PaymentListUrlParams,
    queryStrings?: PaymentListQueryString
  ): Promise<PaymentListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(
        this.getPath(contactListUrlParams.workspaceId),
        {
          params: queryStrings,
        }
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
